import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import * as ValgTypes from '../Store/Valg/Types';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import VeilederSlettingAvRenterDto from '../Models/VeilederSlettingAvRenterDto';
import { VeilederSlettingAvRenterAppState } from '../Store';
import { ResultatValg } from '../Store/Resultat/Types';
import { SlettingAvRenterSatser } from '../Utilities/SlettingAvRenterSatserApi';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultatOwnProps {
    satser: SlettingAvRenterSatser | null,
    valg: ValgTypes.ValgState,
    valuta: string,
}

type ResultatDisplayProps = ResultatOwnProps & MapStateToProps;

function ResultatCbComponent(props: ResultatDisplayProps): JSX.Element {
    const { epiContext } = props;
    const [visCbModal, setVisCbModal] = useState(false);

    function onModalCbClick(e: React.SyntheticEvent<HTMLButtonElement>): void {
        e.preventDefault();
        setVisCbModal(true);
    }

    function onRequestLukkModalCb(): void {
        setVisCbModal(false);
    }

    function fokusOverskrift(): void {
        let overskrift = document.getElementById("js-resultat-cb-component-overskrift");
        if(overskrift !== null) {
            overskrift.focus(); 
            overskrift.scrollIntoView();
        }
    }

    useEffect(() => {
        fokusOverskrift();
        updateLiveMessage();
    }, []);

    return (
            <div className="c-veileder__panel c-veileder__panel--lilac">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content">
                        <h3 id="js-resultat-cb-component-overskrift" className="c-veileder--overskrift c-veileder--overskrift-stor">
                            {contentResolver(epiContext, 'overskriftCb')}
                        </h3>
                        <div className="c-veileder--tekstomraade">
                            {contentResolver(epiContext, 'tekstCb')}
                        </div>
                    </div>

                    <div className="c-veileder__content c-veileder__content--indented">
                        <h4 className="c-veileder--overskrift c-veileder--overskrift-stor">
                            {contentResolver(epiContext, 'overskrift2Cb')}
                        </h4>
                        <div className="c-veileder--tekstomraade">
                            {contentResolver(epiContext, 'tekst2Cb')}
                        </div>
                        <div>
                            <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onModalCbClick}>
                                {contentResolver(epiContext, "modalCbLenketekst")}
                            </button>
                            <ModalCompontent
                                isOpen={visCbModal}
                                onRequestClose={onRequestLukkModalCb}
                                ariaCloseText={resolveRawText(epiContext, "modalCbVilkarAriaLabel")}
                            >
                                <ArticleContentComponent
                                    headerinnhold={contentResolver(epiContext, "modalCbVilkarTittel")}
                                    contentinnhold={contentResolver(epiContext, "modalCbVilkarContent")}
                                />
                            </ModalCompontent>
                        </div>
                    </div>
                </div>
            </div>
    )
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederSlettingAvRenterDto>;
    resultat: ResultatValg;
}

export default connect(
    (state: VeilederSlettingAvRenterAppState, ownProps: ResultatOwnProps): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            resultat: state.resultat,
        };
    }
)(ResultatCbComponent);